import { request } from "../http";

export default {
    // 获取样板间列表
    getTemplateList(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/getTemplateList', params, 'json', { takeGuest: true });
    },

    // 获取样板间收藏列表
    getTemplateFavList(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/getTemplateFavList', params, 'json', { takeGuest: true });
    },

    // 样板间收藏
    templateFav(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/templateFav', params, 'json', { takeGuest: true, checkLogin: true });
    },

    // 获取样板间空间类型列表
    getTemplateSpaceList(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/getTemplateSpaceList', params, 'json', { takeGuest: true });
    },

    // 获取样板间搭配方案列表
    getTemplatePlanList(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/getTemplateUserPlanList', params, 'json', { takeGuest: true });
    },

    // 保存样板间方案
    saveTemplatePlan(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/saveTemplatePlan', params, 'json', { takeGuest: true });
    },

    // 删除样板间搭配方案
    delTemplatePlan(params) {
        return request('post', '/sd_smi/api/v1/H5_Template/delTemplatePlan', params, 'json', { takeGuest: true });
    },

    // 获取样板间信息
    getTemplateInfo(params) {
        return request('post', '/sd_smi/api/v1/Template/getTemplateInfo', params, 'json', { takeGuest: true });
    },

    // 获取样板间搭配详情
    getTemplatePlanDetail(params) {
        return request('get', '/sd_smi/api/v1/H5_Client/getTemplatePlanDetail', params, 'json', { takeGuest: true });
    },
}


// WEBPACK FOOTER //
// ./src/request/apis/template.js